import AssetUploader from "../components/uploads/AssetUploader";

export default class ReportJobs {
  constructor(params) {
    this.params = params;
  }

  assetUploadUrl() {
    return `/report_jobs/${this.params.id}/assets`;
  }

  assetUploadImageLabel() {
    return "Reports";
  }

  show() {
    this.assetUploader = new AssetUploader(this, { showFileName: true });
    this.assetUploader.init();
  }
}
